import React from 'react'
import Table from '../../components/common/Table'
import { EnquiryDTO } from '../../services/apiClient'
import { convertToUserTime } from '../../utils/dateUtils/convertToUserTime'

interface EnquiryTableProps {
  data: EnquiryDTO[];
  handleEdit: (row: EnquiryDTO) => void;
  handleDelete: (row: EnquiryDTO) => void;
  currentPage: number;
  totalPages: number;
  setCurrentPage: (page: number) => void;
  pageSize: number;
  setPageSize: (size: number) => void;
  isLoading: boolean;
}

const EnquiryTable: React.FC<EnquiryTableProps> = ({
  data,
  handleEdit,
  handleDelete,
  currentPage,
  totalPages,
  setCurrentPage,
  pageSize,
  setPageSize,
  isLoading,
}) => {
  return (
    <Table
      columns={[

        {
          label: "Name",
          key: "name",
        },

        {
          label: "Surname",
          key: "surname",
        },

        {
          label: "Email Address",
          key: "emailAddress",
        },

        {
          label: "Contact",
          key: "contact",
        },

        {
          label: "Added",
          key: "createdUtc",
          format: (value: Date) => convertToUserTime(value?.toString() ?? ''),
        },

      ]}
      data={data}
      actions={{
        onEdit: handleEdit,
        onDelete: handleDelete,
      }}
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={setCurrentPage}
      pageSize={pageSize}
      onPageSizeChange={setPageSize}
      isLoading={isLoading}
    />
  );
};

export default EnquiryTable;
